import {useDesignApi} from '~/composables/core/http.js';

export function useSurfaceEditorApi() {
  const apiPaths = {
    projects: '/projects',
    project: '/projects/:projectId',
    surfaces: '/projects/:projectId/surfaces',
    surface: '/projects/:projectId/surfaces/:surfaceId',
    surfacesReorder: '/projects/:projectId/surfaces/reorder',
    elements: '/projects/:projectId/surfaces/:surfaceId/elements',
    element: '/projects/:projectId/surfaces/:surfaceId/elements/:elementId',
    elementsReorder: '/projects/:projectId/surfaces/:surfaceId/elements/reorder',
    templates: '/templates',
    template: '/templates/:id',
    localTemplates: '/surface-editor/system-templates'
  };

  return {
    async createProject({width, height, projectType}) {
      const data = await useDesignApi().post(
        apiPaths.projects,
        {
          body: {
            project_type: projectType,
            surface: {
              width,
              height
            }
          }
        }
      );

      return data.project;
    },

    async getProject({projectId}) {
      const data = await useDesignApi().fetch(
        apiPaths.project,
        {
          params: {
            route: {projectId}
          }
        }
      );

      return data.project;
    },
    deleteProject({projectId}) {
      return useDesignApi().delete(
        apiPaths.project,
        {
          params: {
            route: {projectId}
          }
        }
      );
    },

    createSurface({projectId, width, height, surfaceId, backgroundElementId}) {
      return useDesignApi().post(
        apiPaths.surfaces,
        {
          params: {
            route: {projectId}
          },
          body: {
            surface: {
              id: surfaceId,
              width,
              height,
              background_element_id: backgroundElementId
            }
          }
        }
      );
    },
    deleteSurface({projectId, surfaceId}) {
      return useDesignApi().delete(
        apiPaths.surface,
        {
          params: {
            route: {projectId, surfaceId}
          }
        }
      );
    },
    updateSurface(...args) {
      //todo: remove
      console.log('api.updateSurface', ...args);
    },

    async createElement({projectId, surfaceId, element}) {
      const res = await useDesignApi().post(
        apiPaths.elements,
        {
          params: {
            route: {projectId, surfaceId}
          },
          body: {
            element
          }
        }
      );

      return res.element;
    },
    deleteElement({projectId, surfaceId, element}) {
      return useDesignApi().delete(
        apiPaths.element,
        {
          params: {
            route: {
              projectId,
              surfaceId,
              elementId: element.id
            }
          }
        }
      );
    },
    updateElement({projectId, surfaceId, element}) {
      return useDesignApi().put(
        apiPaths.element,
        {
          params: {
            route: {
              projectId,
              surfaceId,
              elementId: element.id
            }
          },
          body: {element}
        }
      )
    },

    reorderElements({projectId, surfaceId, elementIds}) {
      return useDesignApi().post(
        apiPaths.elementsReorder,
        {
          params: {
            route: {projectId, surfaceId}
          },
          body: {
            element: {
              ids: elementIds
            }
          }
        }
      );
    },

    async getTemplates({designProjectType} = {}) {
      const data = await useDesignApi().fetch(
        apiPaths.templates,
        {
          ...(designProjectType ? {
            params: {
              query: {
                design_project_type: designProjectType
              }
            }
          } : {})
        }
      );

      return data.templates;
    },

    async saveAsTemplate({surface, type = SURFACE_EDITOR_TEMPLATE_TYPES.user, designProjectType}) {
      const data = await useDesignApi().post(
        apiPaths.templates,
        {
          body: {
            template: {
              template_type: type,
              ...(designProjectType ? {design_project_type: designProjectType} : {}),
              body: surface
            }
          }
        }
      );

      return data.template;
    },

    deleteTemplate({template}) {
      return useDesignApi().delete(
        apiPaths.template,
        {
          params: {
            route: {
              id: template.id
            }
          }
        }
      );
    }
  }
}
